/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2020-04-29 16:13:11
 * @LastEditors: yy
 * @LastEditTime: 2020-04-30 10:23:05
 */

let wordcloud

try {
  if (window) {
    wordcloud = require('echarts-wordcloud')
  }
} catch (e) {
  wordcloud = {}
}

export default wordcloud


// WEBPACK FOOTER //
// src/routes/customChart/WordCloud/wordcloud.js